import React, { useState, useMemo } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import PropTypes from "prop-types";

// Assuming Text and styled-components are set up elsewhere
// import Text from "../Text/Text";
// import styled from "styled-components";

export default function CalendarPicker(props) {
    const [msg, setMsg] = useState("");

    const onChange = (date) => {
        if (date) {
            props.onChange(date.toISOString(), props.name);
            setMsg(null);
        } else {
            props.onChange(null, props.name);
        }
    };

    const ExampleCustomInput = React.forwardRef(({ value, onClick, label }, ref) => (
        <input
            className="bg-blue-light rounded-3xl px-5 py-2 w-full"
            onClick={onClick}
            ref={ref}
            value={value}
            placeholder={label}
            readOnly // It's a good practice to make it readOnly to prevent manual input
        />
    ));
    ExampleCustomInput.displayName = 'ExampleCustomInput';


    const selectedDate = useMemo(() => (props.value ? new Date(props.value) : null), [props.value]);

    // Determine if the selected date is the same as the minDate
    const isSameDay = useMemo(() => {
        if (!selectedDate || !props.minDate) {
            return false;
        }
        return moment(selectedDate).isSame(props.minDate, 'day');
    }, [selectedDate, props.minDate]);

    return (
        <>
            <DatePicker
                selected={selectedDate}
                onChange={onChange}
                showTimeSelect={props.subtype === "datetime"}
                dateFormat={props.subtype === "datetime" ? "MM/dd/yyyy HH:mm" : "MM/dd/yyyy"}
                minDate={props.minDate}
                maxDate={props.maxDate}
                minTime={isSameDay ? props.minDate : undefined}
                maxTime={isSameDay ? moment(props.minDate).endOf("day").toDate() : undefined}
                excludeTimes={props.excludeTimes}
                filterTime={props.filterTime}
                wrapperClassName={props.className}
                customInput={<ExampleCustomInput label={props.label} />}
            />
            {msg && <div style={{ color: "red" }}>{msg}</div>}
        </>
    );
}

CalendarPicker.propTypes = {
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    onChange: PropTypes.func,
    name: PropTypes.string,
    label: PropTypes.string,
    subtype: PropTypes.oneOf(['date', 'datetime']),
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    excludeTimes: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
    filterTime: PropTypes.func,
    className: PropTypes.string
};

CalendarPicker.defaultProps = {
    subtype: 'date'
};